<template>
    <div v-if="cargando">
        <div class="row">
            <div class="col-md-12 text-center">
                <h3>Cargando <i class="fa fa-spin fa-spinner"></i></h3> 
            </div>
        </div>
    </div>
    <div v-else>
        <b-row>
            <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                <b-form-group label-cols="2" label="Orden">
                    <b-input-group>
                        <b-form-select v-model="orden" slot="append" @input="listGuide">
                            <option :value="'asc'">Más Antiguo</option>
                            <option :value="'desc'">Más Reciente</option>
                        </b-form-select>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" sm="6"	md="4" lg="4" xl="3">
                 <b-form inline>
                    Desde: <b-input type="date" v-model="f1"/>
                    Hasta: <b-input type="date" v-model="f2"/>
                </b-form>
            </b-col>
            <b-col cols="12" sm="6"	md="4" lg="4" xl="3">
                <b-button 
                    @click="listGuide" 
                    variant="success">
                    Buscar
                </b-button>
            </b-col>
            <b-col md="2">
                <div class="col-md-12 text-center">
                    <b-button variant="secondary" @click="listGuide"><i class="fa fa-sync-alt"></i> </b-button>
                </div>
            </b-col>
            <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
            <b-form-group label-cols="3" label="Mostrar">
                <b-input-group>
                    <b-form-select v-model="limite" slot="append" @input="listGuide">
                        <option :value="10">10</option>
                        <option :value="25">25</option>
                        <option :value="50">50</option>
                        <option :value="100">100</option>
                    </b-form-select>                            
                </b-input-group>                        
            </b-form-group>                    
            </b-col>
            <br>
        </b-row>
        <b-row>
            <b-col cols="12" sm="6"	md="4" lg="4" xl="12">
                <b-table
                    responsive 
                    small
                    outlined
                    :items="guides"
                    :fields="guides_fields"
                    :current-page="pactual"
                    :per-page="limite"            
                    :sort-direction="sortDirection">
                    <template slot="serie" slot-scope="row">
                        {{row.item.serie}} - {{row.item.numero}}
                    </template>
                    <template slot="estado" slot-scope="row">
                        <div v-if="row.item.emitido==1"><span class="badge badge-success">Emitido <i class="fa fa-check"></i></span></div>
                        <div v-else-if="row.item.emitido==0"><span class="badge badge-warning">Procesando <i class="fa fa-spin fa-spinner"></i></span></div>
                        <div v-else-if="row.item.emitido==2"><span class="badge badge-danger">Rechazado <i class="fa fa-times"></i></span></div>
                    </template>
                    <template slot="remitente" slot-scope="row">
                           <div v-if="row.item.adicional.remitente">
                                {{row.item.adicional.remitente.nro}} -  {{row.item.adicional.remitente.razonSocial}}
                           </div>
                           <!-- <div v-else-if="row.item.adicional.empresaSubcontrata">
                            <b-badge variant="primary">Subcontratador</b-badge> {{row.item.adicional.empresaSubcontrata.nro}} -  {{row.item.adicional.empresaSubcontrata.razonSocial}}
                           </div>
                           <div v-else-if="row.item.adicional.tercero">
                            <b-badge variant="primary">Terceros</b-badge> {{row.item.adicional.tercero.nro}} -  {{row.item.adicional.tercero.razonSocial}}
                           </div> -->
                    </template>
                    <template slot="receptor" slot-scope="row">
                        <template v-if="row.item.receiver">
                            {{row.item.idReceptor}} - {{row.item.receiver.razonSocial}}
                         </template>
                        <template v-else>
                            {{ row.item.idReceptor }}
                        </template>         
                    </template>
                    <template slot="emision" slot-scope="row">
                            {{ row.item.fechaEmision | moment('D/M/Y hh:mm:ss A') }} 
                    </template>
                    <template slot="acciones" slot-scope="row">
                        <template v-if="row.item.emitido!=2">
                        <b-button-group>
                            <button v-show="!row.item.loading" type="button" class="btn" size="sm" @click="mostrarDetalles(row, row.index)" title="Mas opciones">
                                <template v-if="!row.item.mostrardetalles">
                                    <i class="fa fa-plus"></i>
                                </template>
                                <template v-else>
                                    <i class="fa fa-minus"></i>
                                </template>
                            </button>
                            <b-button v-b-modal.modalprev v-b-tooltip.hover @click="viewPdf(row.item)"><i class="fa fa-tv" title="Vista Previa"></i></b-button>
                            <b-button @click="setInvoice(row.item)" v-b-modal.sendfacturaemail1 v-b-tooltip.hover><i class="fa fa-share-alt" title="Compartir Documento" aria-hidden="true"></i></b-button>
                            <b-button @click="downloadPdf(row.item)" v-b-tooltip.hover><i class="fa fa-file-pdf" title="Descargar PDF"></i></b-button>
                            <b-button v-if="row.item.emitido==0" class="disabled" :disabled="true"><i class="fa fa-file-archive" title="Descargar CDR"></i></b-button>
                            <b-button v-else @click="downloadCdr(row.item)"><i class="fa fa-file-archive" title="Descargar CDR"></i></b-button>
                            <b-button v-if="row.item.emitido==0" class="disabled" :disabled="true" v-b-tooltip.hover><i class="fa fa-file-code" title="Descargar XML"></i></b-button>
                            <b-button v-else @click="downloadXml(row.item)" v-b-tooltip.hover><i class="fa fa-file-code" title="Descargar XML"></i></b-button>                      
                        </b-button-group>
                        </template>
                        <template v-else>
                            <b-button @click="downloadCdr(row.item)" title="Descargar CDR"><i class="fa fa-file-archive"></i></b-button>
                            <b-button v-if="row.item.emitido==2" @click="estadoEmision(row.item)" v-b-modal.motivorechazo7 v-b-tooltip.hover title="Estado de la emision" class="btn" variant = "primary"><i class="fa fa-eye text-white"></i></b-button>
                        </template>
                    </template>
                    <!-- detalles -->
                    <template slot="row-details" slot-scope="row">
                        <div class="tabla">
                        <b-table
                            head-variant="light"
                            small                           
                            bordered
                            :items="row.item.lista"
                            :fields="items_Guia">
                        <template slot="cantidad" slot-scope="row">
                            <div v-if="row.item.cantidad && row.item.cantidad > 0">
                                {{ Number.parseFloat(row.item.cantidad).toFixed(2)}}
                            </div>
                        </template>
                        </b-table>
                        </div>
                    </template>
                </b-table>
            </b-col>
        </b-row>
        <div class="row">
        <div class="col-md-9">
            <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
        </div>
        <div class="col-md-3">
            <b-pagination size="md" :total-rows="total" v-model="currentPage" :per-page="limite" @input="listGuide"></b-pagination>
        </div>
    </div>
        <b-modal id="modalprev" size="lg" title="Vista Previa" cancel-title="Cerrar" v-model="previaguia">
            <template v-if="cargandopdf2"><div class="text-center"><h3><i class="fa fa-spin fa-spinner"></i></h3> Cargando vista previa</div></template>
            <template v-else>
                <template v-if="pdfobject !==''">
                <b-embed :src="'data:application/pdf;base64,'+ pdfobject" allowfullscreen></b-embed>
                </template>
            </template>                
        </b-modal>
        <b-modal id="motivorechazo7" title="Motivo del Rechazo" v-model="motivoRechazo">
            <div role="group">
                <div v-if="spinoff">
                    <div class="row">
                        <div class="col-md-12 text-center">
                            <h3>Cargando <i class="fa fa-spin fa-spinner"></i></h3>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="row">
                        <div class="col-md-12 text-center">
                            <h6>{{ descripcionRechazo }}</h6>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="modal-footer" class="w-100">
                <b-btn v-if="!sendcorreo" size="sm" class="float-right" variant="primary" @click="motivoRechazo=!motivoRechazo">
                    Ok
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="modalguide" title="Compartir Documento" v-model="previacorreo">
            <div role="group">
                <label for="inputLive">Enviar por Correo: <i class="fa fa-envelope fa-lg" aria-hidden="true"></i></label>
                <b-form-input 
                    style="border-color:black" 
                    v-model="recipients" type="email" 
                    @keyup.enter="sendMail(guide)"
                    placeholder="Ingresa un correo ó varios separados por comas (,)">
                </b-form-input>
                <b-form-text 
                    style="font-size: small !important; color: #ea0909 !important">
                    Ingresa un correo ó varios separados por comas (,)
                </b-form-text>
            </div>
            <b-row>
                <b-col>
                    <b-btn v-if="!sendcorreo" size="sm" class="float-right" variant="primary" @click="sendMail(guide)">Enviar</b-btn>
                    <b-btn v-else size="sm" class="float-right" variant="secondary"><i class="fa fa-spin fa-spinner"></i> Enviando...</b-btn>
                </b-col>
                <!-- <b-col v-else>
                   <b-button class="float-right" disabled variant="secondary" size="sm" > Enviar</b-button>
                </b-col> -->
            </b-row>
            <hr class="mt-3">
            <h5>Correos en módulo Negocios:</h5>
            <h5><li style="list-style:none" class="mr-1" variant="dark" v-for="(item,index) in reciveEmail" :key="index">
                <b-badge pill variant="light">{{item}}
                <i @click="borrarCorreo(index)" class=" fa fa-times-circle text-dark cursor"></i></b-badge> 
                </li>
            </h5>
            <b-row>
                <b-col v-if="!sendcorreoNegocios">
                    <b-button v-if="recipients!=''" :disabled="mostraremail" class="float-right" size="sm" @click="enviarEmail(invoice)" variant="primary">Enviar a todos</b-button>
                    <b-button v-else  :disabled="mostraremail" class="float-right" size="sm" @click="enviarEmail(invoice)" variant="primary">Enviar</b-button>
                </b-col>
                <b-col v-else-if="sendcorreoNegocios">
                    <b-buttom class="float-right"> <i class="fa fa-spin fa-spinner"></i> Enviando... </b-buttom>
                </b-col>
            </b-row>
            <div slot="modal-footer"></div>
        </b-modal>
        <b-modal v-model="modalError500">
            <b-alert show variant="danger">
                <div class="text-center">
                <strong>    
                    <i class="fa fa-2x fa-exclamation-circle"></i>
                    Error 500 - Error en el servidor
                </strong>
                    <p>Si el mensaje se vuelve a mostrar, por favor notificar al área de soporte.</p> 
                 <i class="fas fa-file-code" @click="copyJsonToClipboard" style="cursor: pointer;"></i> JSON
                </div>
            </b-alert>
            <template v-slot:modal-footer>
                <b-button block variant="primary" @click="refreshPage">Actualizar y volver a intentar</b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
import GuiaRemisionTransportistaConsulta from '@/components/guiaremisiontransportista/GuiaRemisionTransportistaConsulta.vue'
import axios from 'axios'
import download from 'downloadjs'
export default {
    name:GuiaRemisionTransportistaConsulta,
    comments:{
        download,
    },
    data() {
        return {
            cargando: true,
            currentPage: 1,
            limite: 10,
            orden: 'desc',
            f1:'',
            f2:'',
            guides: [],
            guides_fields: [
                {key: 'serie', label: 'Serie-Número', sorteable: true},
                {key: 'emision', label: 'Emisión', sorteable: true},
                {key: 'remitente', label: 'Remitente', sorteable: true},
                {key: 'receptor', label: 'Receptor', sorteable: true},
                {key: 'estado', label: 'Estado', sorteable: true},
                {key: 'acciones', label: 'Acciones'}
            ],
            items_Guia: [
                {key: 'cantidad', label: 'Cantidad', sorteable: true},
                {key: 'unidadMedida', label: 'Emisión', sorteable: true},
                {key: 'descripcion', label: 'Descripcion'},
                {key: 'codigoItem', label: 'Codigo Item', sorteable: true},
                {key: 'codigoProductoSunat', label: 'Codigo Sunat', sorteable: true}  
            ],
            total: 0.00,
            desde: 0.00,
            hasta: 0.00,
            sortDirection: 'asc',
            pactual: 1,
            previaguia: false,
            cargandopdf2: false,
            pdfobject: '',
            cargandopdf: false,
            motivoRechazo: false,
            spinoff: false,
            descripcionRechazo: '',
            sendcorreo: false,
            previacorreo: false,
            modalError500:false,
            errorJson: null,
            customers:[],
            reciveEmail:[],
            mostraremail: true,
            recipients: '',
            sendcorreoNegocios:false,
            guide: {},
        }
    },
    mounted(){
         this.listGuide();
         this.listTerceros();
    },
    computed:{

    },
    watch:{

    },
    methods: {
        listGuide: function () {
            let listaGuia = []
            let idGuiaTransportista = ''
            let mapa = []
            let dia1;
            let dia2;
            if(this.f1 === "" && this.f2 ===""){
                dia1 =  ""
                dia2 = ""
            }else{
                dia1 = this.$moment(this.f1).format('YYYY-MM-DD HH:mm:ss')
                dia2 = this.$moment(this.f2).format('YYYY-MM-DD 23:59:59')          
            }
            this.cargando = true;
            axios
            .post(process.env.VUE_APP_API_URL + 'guiaremitente/guiatransportista/listar', {
                token: this.$store.getters.userToken,
                f1:dia1,
                f2:dia2,
                page: this.currentPage,
                limit: this.limite,
                order: this.orden

            })
            .then(response => (
                this.guides = response.data.data,
                this.total = response.data.total,
                this.desde = response.data.from,
                this.hasta = response.data.to,
                this.cargando = false,
                mapa = this.guides,
                this.guides.forEach(function(element){
                    element.loading = false
                    idGuiaTransportista = element.idGuiaTransportista
                    listaGuia = JSON.parse(element.adicional)
                    mapa.forEach(function(dato){
                    if(dato.idGuiaTransportista == idGuiaTransportista){
                        dato.adicional = listaGuia
                    }
                })
               }),
               this.guides = mapa
            ))
            .catch(error =>  {
                console.log(error)
            })
        },
        viewPdf: function (data) {
            this.pdfobject = ''
            this.cargandopdf2 = true
            axios
           .post(process.env.VUE_APP_API_URL + 'guiaremitente/guiatransportista/pdf',{
               token: this.$store.getters.userToken,
               id: data.idGuiaTransportista
           })
           .then(response => (
               this.pdfobject = response.data.base64,
               this.cargandopdf2 = false
           ))
           .catch(function (error){
            if (error.response && error.response.status === 500) {
                    this.modalError500 = true
                    this.errorJson = error.response.data;
                }
                this.$snotify.danger(error.data.msg, 'Error')
               
           })      
        },
        refreshPage() {
            this.$router.go(0); //recagar la pagina al incio
        },
        async copyJsonToClipboard() {
            try {
                await navigator.clipboard.writeText(JSON.stringify(this.errorJson));
                this.$snotify.success('JSON copiado al portapapeles', 'Éxito');
            } catch (err) {
                this.$snotify.error('No se pudo copiar el JSON al portapapeles', 'Error');
            }
        },
        downloadPdf: function (data){
            let tag = document.createElement('i')
            tag.classList.add('fa','fa-spin', 'fa-spinner')
            let name = data.serie + '-' + data.numero + '.pdf'
            let file = 'data:application/pdf;base64,'+ data.pdf
            this.cargandopdf = true
            this.$swal({
                title: 'Procesando Descarga',
                content: tag,
                icon: 'info',
                buttons: false,
                dangerMode: false
            })
           axios
           .post(process.env.VUE_APP_API_URL + 'guiaremitente/guiatransportista/pdf',{
               token: this.$store.getters.userToken,
               id: data.idGuiaTransportista
           })
           .then(response => (
               file = 'data:application/zip;base64,'+ response.data.base64,
               this.cargandopdf = false,               
               download(file, name,'application/pdf'),
               this.$swal.close()
           ))
           .catch(function (error){
               this.$swal.close()
           })            
        },
        mostrarDetalles: function (row, index) {
            if(row.detailsShowing){
                row.toggleDetails()
                this.guides[index].mostrardetalles = false
            }else{
                 
                this.guides[index].mostrardetalles = true
                this.guides[index].loading = true
                
                if(this.guides[index].lista.length == 0){
                    setTimeout(() => 
                        this.detallesDocumento(row, index)
                    , 10);  
                }else{
                    this.guides[index].loading = false
                    row.toggleDetails()
                } 
            }
        },
        detallesDocumento: function (row, index) {
            axios
            .post(process.env.VUE_APP_API_URL + 'guiaremitente/guiatransportista/items',{
                token: this.$store.getters.userToken,
                idguia: row.item.idGuiaTransportista
            })
            .then(response => (
                this.parseDetallesDocumento(response.data.response, row, index)
            ))
            .catch(error => (  
                this.guides[index].mostrardetalles = false
            )) 
        },
        parseDetallesDocumento: function (value, row, index) {
            let t = [];
            value.forEach(element => {  
                t.push(element)
            });
            this.guides[index].lista = t;
            this.guides[index].loading = false
            if(value.length > 0){
                row.toggleDetails()
            }
        },
        downloadCdr: function (data){
            let tag = document.createElement('i')
            tag.classList.add('fa','fa-spin', 'fa-spinner')
            let name = 'CDR-' + data.serie + '-' + data.numero + '.zip'
            let file = 'data:application/pdf;base64,'+ data.pdf
            this.cargandocdr = true
            this.$swal({
                title: 'Procesando Descarga',
                content: tag,
                icon: 'info',
                buttons: false,
                dangerMode: false
            })
           axios
           .post(process.env.VUE_APP_API_URL + 'guiaremitente/guiatransportista/cdr',{
               token: this.$store.getters.userToken,
               id: data.idGuiaTransportista
           })
           .then(response => (
               file = 'data:application/zip;base64,'+ response.data.msg.xml,
               this.cargandocdr = false,
               download(file, name,'application/zip'),
               this.$swal.close()
           ))
           .catch(function (error){

           })
        },
        downloadXml: function (data){
            let xml = ''
            let file = ''
            let name = data.serie + '-' + data.numero + '.zip'
            let tag = document.createElement('i')
            this.cargandopdf = true
            tag.classList.add('fa','fa-spin', 'fa-spinner')
            this.$swal({
            title: 'Obteniendo XML',
            content: tag,
            icon: 'info',
            buttons: false,
            dangerMode: false
            })
            axios
            .post(process.env.VUE_APP_API_URL + 'guiaremitente/guiatransportista/xml', {
                token: this.$store.getters.userToken,
                id: data.idGuiaTransportista
            })
            .then(response => (
                xml = response.data.response.xml,
                file = 'data:application/zip;base64,'+ xml,
                this.downloadxml(file, name, xml),
                this.$swal.close()
            ))
            .catch(error => (
                this.$snotify.error('Error al descargar el archivo', 'Error')
            ))
        },
        downloadxml: function (file, name, xml) {
            if(xml != null){
                download(file, name,'application/zip')
            }else{
                this.$snotify.error('El documento aun no tiene constancia porque esta en proceso!', 'Error')
            }  
        },
        estadoEmision: function (value) {
            this.spinoff = true
            axios
            .post(process.env.VUE_APP_API_URL + 'documento/motivorechazo', {
                token: this.$store.getters.userToken,
                serie: value.serie,
                numero: value.numero,
                tipo: '13'
            })
            .then(response => ( 
                this.descripcionRechazo = response.data.msg.descripcion,
                this.spinoff = false
            ))
            .catch(error => (
                this.$snotify.error(error.response.data, 'Error'),
                this.motivoRechazo = false,
                this.spinoff = false
            )) 
        },
        setInvoice: function(data) {
            this.previacorreo = true;
            this.invoice = data;
            this.reciveEmail = []
            this.listTerceros();
            let valordata = data
            let pasandoCorreoTerceros = {}
            this.customers.forEach(function(element){
                if(valordata.receiver.idReceptor == element.documento){
                pasandoCorreoTerceros = element.emailEnvio
                }      
            })
            this.reciveEmail = pasandoCorreoTerceros;
            if(this.reciveEmail && this.reciveEmail.length > 0){
                this.mostraremail = false;
            }else{
                this.mostraremail = true;
            }
           
        },
        listTerceros: function() {
        axios
            .post(process.env.VUE_APP_API_URL + "terceros/listar/1", {
            token: this.$store.getters.userToken,
            page: this.currentPageTerceros,
            order: this.ordenTerceros
            })
            .then(response =>(
                this.customers = response.data
            ))
            .catch(error => (
            console.log(error)
            ))
        },
        sendMail: function () {
            this.invoice;
            this.previacorreo = true
            this.sendcorreo = true
            axios
            .post(process.env.VUE_APP_API_URL + 'guiaremitente/guiatransportista/mail', {
                token: this.$store.getters.userToken,
                id: this.invoice.idGuiaTransportista,
                mail: this.recipients 
            })
            .then(response => (
                this.previacorreo = false,
                this.sendcorreo = false,
                this.$snotify.success(response.data.msg, 'Exito')          
                ))
            .catch(error => (
                this.previacorreo = false,
                this.sendcorreo = false,
                this.$snotify.error(error.response.data.response, 'Error')
            ))
        },
        enviarEmail: function(data) {
            for (let i = 0; i < this.reciveEmail.length; i++) {
                this.reciveEmail[i] + ","
            }
            let cadena = this.reciveEmail.join(",");
            if(this.recipients !=''){
                this.sendMail(data);  
            }  
            this.previacorreo = true;
            this.sendcorreoNegocios = true;
            axios
                .post(process.env.VUE_APP_API_URL + "guiaremitente/guiatransportista/mail", {
                token: this.$store.getters.userToken,
                id: data.idGuiaTransportista,
                mail: cadena
                })
                .then(
                response => (
                    (this.previacorreo = false),
                    (this.sendcorreoNegocios = false),
                    this.alertaenvio(response.data.msg)
                )
                )
                .catch(
                error => (
                    (this.previacorreo = false),
                    (this.sendcorreoNegocios = false),
                    this.$snotify.error(error.response.data.response, "Error")
                )
                );
        },
        alertaenvio(data){
            if(this.recipients == ''){
                this.$snotify.success(data, "Exito")
            }
        },
        borrarCorreo(index){
            this.reciveEmail.splice(index, 1)
            if(this.reciveEmail.length > 0){
                this.mostraremail = false;
            }else{
                this.mostraremail = true;
            }
        },
        setGuide: function (data) {
            this.guide = data
        },
    },
}
</script>
<style scoped>
.tabla{
    padding: 1%;
}
</style>